import { render, staticRenderFns } from "./GalleryPhoto.vue?vue&type=template&id=3f359c31&scoped=true"
import script from "./GalleryPhoto.vue?vue&type=script&lang=js"
export * from "./GalleryPhoto.vue?vue&type=script&lang=js"
import style0 from "./GalleryPhoto.vue?vue&type=style&index=0&id=3f359c31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f359c31",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OptimizedImage: require('/app/components/ui/OptimizedImage.vue').default})
